<template>
  <div class="button-up flex" :class="{mobile: $vuetify.breakpoint.xsOnly}" @click="toTop" v-if="scrollY > 150">
    <v-icon v-if="$vuetify.breakpoint.xsOnly" size="24">arrow_upward</v-icon>
    <span v-else class="label"> To top <v-icon >arrow_upward</v-icon></span>
  </div>
</template>

<script>
    export default {
        name: 'ButtonUp',
        data() {
          return {
            scrollY: window.scrollY
          }
        },
        methods:{
          toTop(){
            window.scrollTo({
              top: 0,
              left: 0,
            });       
          },
          handleScroll(){
            this.scrollY = window.scrollY
          }
        },
        created: function () {
            window.addEventListener('scroll', this.handleScroll);
        },
        destroyed: function () {
            window.removeEventListener('scroll', this.handleScroll);
        }        
    }
</script>

<style lang="scss" scoped>
  .button-up{
    position: fixed; 
    bottom: 28px;
    left: 0px; 
    z-index: 99;
    border: none; 
    outline: none; 
    background-color: lightblue;
    color: white; 
    cursor: pointer; 
    padding: 15px; 
    font-size: 18px; 
    opacity: 0.01;
    height: 50px;
    z-index: 0;
    width: 290px;
    &.mobile{
      right: 20px;
      left: unset;
      width: 60px;
      height: 38px;
      opacity: 1;
      border-radius: 50px;
      font-size: 15px;
      line-height: 43px;
      padding: 0px;
      bottom: 20px;
      text-align: center;
    }
  }
  .button-up:hover {
    background-color: #555;
    opacity: 0.8;
  }  
  .label{
    bottom: 10px;
    position: absolute;
    left: 100px;
  }
</style>
